import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getAd, createUniqueAdId } from "@wattpad/client-platform-web-ads";

const AdContainer = ({ placement, adData, wrapperClassName }) => {
  const [uniquePlacement] = useState(createUniqueAdId(placement));

  const initializeAd = () => {
    getAd({
      ...adData,
      placement: uniquePlacement
    });
  };

  useEffect(initializeAd, []);

  return <div className={wrapperClassName} id={uniquePlacement} />;
};

AdContainer.propTypes = {
  placement: PropTypes.string.isRequired,
  adData: PropTypes.object,
  wrapperClassName: PropTypes.string.isRequired
};

export default AdContainer;
